import { apiFetch } from '../lib/http';
import type {
  AuthUser,
  LoginData,
  LoginRequest,
  RegisterRequest,
  RegistrationStatus,
} from '../types/api';

export function login(body: LoginRequest) {
  return apiFetch<LoginData>('/auth/login', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function changePassword(old_password: string, new_password: string) {
  return apiFetch<Record<string, never>>('/auth/change-password', {
    method: 'POST',
    body: JSON.stringify({ old_password, new_password }),
  });
}

export function me() {
  return apiFetch<AuthUser>('/auth/me');
}

export function register(body: RegisterRequest) {
  return apiFetch<{ accepted: boolean; message: string }>('/auth/register', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function registrationStatus(principal: string, password: string) {
  return apiFetch<RegistrationStatus>('/auth/registration/status', {
    method: 'POST',
    body: JSON.stringify({ principal, password }),
  });
}

export function resubmitRegistration(body: {
  principal: string;
  password: string;
  name: string;
  role: 'student' | 'teacher';
  class_name?: string;
  grade?: string;
}) {
  return apiFetch<{ accepted: boolean; message: string }>('/auth/registration/resubmit', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function kioskHeartbeat() {
  return apiFetch<Record<string, never>>('/auth/kiosk/heartbeat', { method: 'POST' });
}

export function kioskLogout() {
  return apiFetch<Record<string, never>>('/auth/kiosk/logout', { method: 'POST' });
}
